import { FormControlLabel } from '@mui/material';
import CheckboxRoot from '@mui/material/Checkbox';
import { ICheckbox } from './types';

const Checkbox = ({
  onChange = () => { },
  checked = false,
  label = '',
  labelPlacement = 'end',
  ...props
}: ICheckbox) => {
  return (
    <FormControlLabel
      label={label}
      control={<CheckboxRoot checked={checked} onChange={onChange} />}
      labelPlacement={labelPlacement}
      {...props}
      sx={{ m: 0, ...props.style }}
    />
  );
};

export default Checkbox;
